import React from 'react'
import { useTranslation } from 'react-i18next'
import { observer } from 'mobx-react'
import cn from 'classnames'
import { Confirm } from 'semantic-ui-react'
import useStores from '@stores/useStores'

const StepContainer = ({ children }) => {
  const { surveyState, appState } = useStores()
  const { t } = useTranslation()
  const { language_code } = surveyState
  const confirmPerfectScoring = () => surveyState.acceptPerfectScoring()
  const textDirection = appState.getTextDirection(language_code)

  return (
    <div className={cn('custom-container flex vertical')}>
      {children}
      <Confirm
        dir={textDirection}
        className='survey-confirm'
        open={surveyState.showPerfectScoreWarning}
        onConfirm={confirmPerfectScoring}
        header={t('Please be thoughtful with your responses.')}
        confirmButton={t('Okay')}
        cancelButton={null}
        closeOnDimmerClick={false}
        content={t(
          'Answering a survey with all "5 - Best" responses is often viewed as a negative by hiring managers.'
        )}
        size='tiny'
      />
    </div>
  )
}

export default observer(StepContainer)
